define('css', function () {
    return {
        load: function (name, require, onload, config) {
            var linkElement = document.createElement('link');
            linkElement.href = require.toUrl(name);

            var isLoaded = Array.prototype.slice.call(
                document.getElementsByTagName('head')[0].querySelectorAll('link[rel=stylesheet]')
            ).some(function (link) {
                return link.href === linkElement.href;
            });

            if (!isLoaded) {
                linkElement.rel = 'stylesheet';
                linkElement.type = 'text/css';
                linkElement.onload = onload;
                linkElement.onerror = onload.error;
                document.getElementsByTagName('head')[0].appendChild(linkElement);
            } else {
                onload({});
            }
        }
    };
});